// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"di","pgSpeechBox":"di","speech-list-box":"dj","speechListBox":"dj"};